<div class="login-component-wrap container mx-auto">
    <div class="mx-auto login-component-inner">
        <h1 class="accent-title">Register</h1>
        <p>Please enter your details</p>
        <form [formGroup]="registerForm" (ngSubmit)="register()">
            <div class="input-wrapper mx-auto flex flex-col items-center mt-10">
                <mat-form-field appearance="fill" color="primary">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput formControlName="email">
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary">
                    <mat-label>Phone</mat-label>
                    <input type="number" matInput formControlName="phone">
                </mat-form-field>
                <div class="button-wrapper mt-4 mb-2">
                    <button mat-flat-button color="primary">Register</button>
                </div>
            </div>
        </form>
        <p>Already have an account? <a (click)="goToLogin()">Login</a></p>
    </div>
</div>